var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:[_vm.$style.content, {
    [_vm.$style.contentGrid]: _vm.flexLayout,
  }]},_vm._l((_vm.resources),function(resource){return _c('li',{key:resource.id || resource._id,class:[_vm.$style.resource, _vm.$style.highlightsListItem]},[(_vm.icon)?_c(_vm.icon,{tag:"component",class:_vm.$style.icon}):_vm._e(),_c('a',{class:_vm.$style.resourceLink,attrs:{"href":resource.href,"rel":"noopener noreferrer"}},[_vm._v(" "+_vm._s(resource.name)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }